import { render, staticRenderFns } from "./EduExerciseExam.vue?vue&type=template&id=72e5f0a6&scoped=true"
import script from "./EduExerciseExam.vue?vue&type=script&lang=js"
export * from "./EduExerciseExam.vue?vue&type=script&lang=js"
import style0 from "./EduExerciseExam.vue?vue&type=style&index=0&id=72e5f0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5f0a6",
  null
  
)

export default component.exports